import { render } from "./about.vue?vue&type=template&id=ff18dc14"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import exportComponent from "/Users/baptiste/P_8678-Amis-des-musees-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__